/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {animate, animateChild, keyframes, query, state, style, transition, trigger} from '@angular/animations';

export const animations = [
    trigger(
        'activeTransitionItem', [
            state('false', style({
                'color': '#000',
                'background-color': '#fff'
            })),
            state('true', style({
                'color': '#fff',
                'background-color': '#607d8b'

            })),
            transition('true => false', [
                animate('200ms ease', keyframes([
                    style({
                        'color': '#fff',
                        'background-color': '#607d8b'

                    }),
                    style({
                        'color': '#000',
                        'background-color': '#fff'
                    })
                ])),
                query('@activeTransitionItemIcon', [
                    animateChild()
                ])
            ]),
            transition('false => true', [
                animate('200ms ease', keyframes([
                    style({
                        'color': '#000',
                        'background-color': '#fff'
                    }),
                    style({
                        'color': '#fff',
                        'background-color': '#607d8b'

                    })
                ])),
                query('@activeTransitionItemIcon', [
                    animateChild()
                ])
            ])
        ]
    ),
    trigger(
        'activeTransitionItemIcon', [
            state('true', style({
                'color': '#607d8b',
                'background-color': '#fff'
            })),
            state('false', style({
                'color': '#fff',
                'background-color': '#607d8b'

            })),
            transition('true => false', [
                animate('200ms ease', keyframes([
                    style({
                        'color': '#607d8b',
                        'background-color': '#fff'
                    }),
                    style({
                        'color': '#fff',
                        'background-color': '#607d8b'
                    })
                ]))
            ]),
            transition('false => true', [
                animate('200ms ease', keyframes([
                    style({
                        'color': '#fff',
                        'background-color': '#607d8b'
                    }),
                    style({
                        'color': '#607d8b',
                        'background-color': '#fff'
                    })
                ]))
            ])
        ]
    )];
